const doc = [({"en":({"js":({"admin":({"orders":({"index":({"mark_the_order_to_require_manual_action":"Mark the order to require manual action?"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;